import { render, staticRenderFns } from "./NgInput.vue?vue&type=template&id=01938b22&scoped=true&"
import script from "./NgInput.vue?vue&type=script&lang=js&"
export * from "./NgInput.vue?vue&type=script&lang=js&"
import style0 from "./NgInput.vue?vue&type=style&index=0&id=01938b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01938b22",
  null
  
)

export default component.exports